export default {
  headerTitle: 'Метки',
  markerTitle: 'Метка {0}',
  markersHint: 'Кликните на карте чтобы добавить метку',
};
